// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__1-N9G","autoHeight":"Loader_autoHeight__L6+h3","ldsRing":"Loader_ldsRing__FlgHJ"};